import React from 'react';
import { ContextMenuAction } from 'src/components/common/ContextMenu';
import ROWLine from 'src/models/ROWLine';
import Card from 'src/components/common/Card.redesign';
import AgreementUtil from 'src/util/AgreementUtil';

interface IROWListCardProps {
    key?: string;
    actions?: ContextMenuAction[];
    rowLine: ROWLine;
    isActive: boolean;
    onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const ROWListCard = (props: IROWListCardProps) => {

    const badgeInfo = (
        <span style={{ fontSize: '.9rem', position: 'relative', marginTop: '.2rem', display: 'block' }}>
            <span style={{ paddingLeft: '1rem', fontWeight: 600 }}>Line Length: </span>
            {props.rowLine.lineLength}
            <span style={{ paddingLeft: '1rem', fontWeight: 600 }}>Tract Count: </span>
            {props.rowLine.surfaceTractNumbers ? props.rowLine.surfaceTractNumbers.length : 0}
        </span>
    );

    return (
        <Card
            className={`inner-card ${props.isActive ? 'active' : ''}`}
            onClick={(e) => props.onClick(e)}
            badge={`${props.rowLine.lineNumber}`}
            rightBadgePanel={badgeInfo}
            contextActions={props.actions}
            newContext={true}
            showMenu={true}
        >
            <div>
                <div style={{ width: '100%', padding: '0.5rem' }}>
                    <span 
                        style={{ visibility: (props.rowLine.tags?.length ? props.rowLine.tags?.length : 0) < 1 ? 'hidden' : 'visible',
                        fontWeight: 'bold', display: 'inline-block', marginRight: '.6rem', whiteSpace: 'nowrap' }}
                    >Tags:
                    </span>
                    <span>
                        {props.rowLine?.tags?.length > 0 ? AgreementUtil.tagsToString(props.rowLine?.tags) : 'No Tags'}
                    </span>
                </div>
                <div style={{ width: '100%', padding: '0.5rem' }}>
                    <span
                        style={{
                            maxHeight: '2rem',
                            width: '65%',
                            position: 'relative',
                            top: '.5rem',
                            display: 'inline-flex',
                        }}
                    >
                        <span style={{ fontWeight: 'bold', display: 'inline-block', marginRight: '.6rem', whiteSpace: 'nowrap' }}>Line Name:</span>
                        <span>{props.rowLine.name}</span>
                    </span>
                </div>
                <div style={{ width: '100%', padding: '0.5rem' }}>
                    <span
                        style={{
                            maxHeight: '2rem',
                            position: 'relative',
                            display: 'inline-flex',
                        }}
                    >
                        <span
                            style={{ fontWeight: 'bold', display: 'inline-block', marginRight: '.6rem', whiteSpace: 'nowrap' }}
                        >
                            POB Information:
                        </span>
                        <span
                            style={{
                                display: 'inline-block',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                zIndex: 0,
                                height: 'auto',
                            }}
                        >
                            {props.rowLine.pobParcelName?.length > 0 ? `Parcel Id ${props.rowLine.pobParcelId || 'N/A'} - ${props.rowLine.pobParcelName}` : 'No Information'}
                        </span>
                    </span>
                </div>
                <div style={{ width: '100%', padding: '0.5rem' }}>
                    <span
                        style={{
                            maxHeight: '2rem',
                            position: 'relative',
                            display: 'inline-flex',
                        }}
                    >
                        <span
                            style={{ fontWeight: 'bold', display: 'inline-block', marginRight: '.6rem', whiteSpace: 'nowrap' }}
                        >
                            POT Information:
                        </span>
                        <span
                            style={{
                                display: 'inline-block',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                zIndex: 0,
                                height: 'auto',
                            }}
                        >
                            {props.rowLine.potParcelName?.length > 0 ? `Parcel Id ${props.rowLine.potParcelId || 'N/A'} - ${props.rowLine.potParcelName}` : 'No Information'}
                        </span>
                    </span>
                </div>
                
            </div>
        </Card>
    );
};

export default ROWListCard;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ROWListCard.tsx